import {
  generic_get_network_request,
  generic_post_network_request,
  generic_delete_network_request,
} from '../axiosClient/axiosClient';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface Role_Type {
  role_id: number;
  role_name: string;
  company_id: number;
  created_by: number;
  created_at: string;
}

export interface RoleUser_Type {
  user_role_id: number;
  user_id: number;
  first_name: string;
  last_name: string;
  email_id: string;
}

export interface GetRoles_Response_Type {
  data: Role_Type[];
}

export interface GetRoleUsers_Response_Type {
  data: RoleUser_Type[];
}

export interface CreateRole_Payload_Type {
  company_id: number;
  role_name: string;
  created_by: number;
}

export interface AddUsersToRole_Payload_Type {
  user_ids: number[];
  assigned_by: number;
}

// ─── API Functions ────────────────────────────────────────────────────────────

export const getRolesByCompany = (company_id: number) =>
  generic_get_network_request<GetRoles_Response_Type>(`roles/${company_id}`);

export const createRole = (payload: CreateRole_Payload_Type) =>
  generic_post_network_request<{ role_id: number }, CreateRole_Payload_Type>('roles', payload);

export const deleteRole = (role_id: number) =>
  generic_delete_network_request<{ message: string }>(`roles/${role_id}`);

export const getUsersByRole = (role_id: number) =>
  generic_get_network_request<GetRoleUsers_Response_Type>(`roles/${role_id}/users_per_role`);

export const addUsersToRole = (role_id: number, payload: AddUsersToRole_Payload_Type) =>
  generic_post_network_request<{ message: string }, AddUsersToRole_Payload_Type>(
    `roles/${role_id}/users_per_role`,
    payload
  );

export const removeUserFromRole = (role_id: number, user_role_id: number) =>
  generic_delete_network_request<{ message: string }>(`roles/${role_id}/users_per_role/${user_role_id}`);
